module.exports = __webpack_public_path__ + "img/schedule.31473ffe.svg";